<template>
  <div id="app">
    <div id="header">
      <img class="logo" :src="require(`@/assets/img/company_logo.${logoImageType}`)" :alt="groupName + 'logo'">
      <div id="view-switch">
        <button class="square map" :class="viewMode == 'map' ? 'active':''" @click.prevent="viewMode = 'map'"></button>
        <button class="square list" :class="viewMode == 'list' ? 'active':''" @click.prevent="viewMode = 'list'"></button>
      </div>
    </div>
    <div id="page">
      <div id="sidebar" v-show="viewMode == 'list'">
        <div class="cities-wrap">
          <div v-for="(city, index) in citiesFilter" v-bind:key="index" class="city-item" :class="city.visible ? 'show-bottom':''">
            <div class="top" @click="city.visible = !city.visible">
              <div class="name">
                {{ city.data.name }}
              </div>
              <div class="percent" :style="{ color: checkIfNegative(city.avg) ? '#FF0' : perc2color(city.avg) }">
                {{ checkIfNegative(city.avg) ? 'Geen data' : Math.round(city.avg) }}{{ checkIfNegative(city.avg) ? '' : '%' }}
              </div>
              <div class="drive" v-if="city.travelTime">
                {{ city.travelTime }}
              </div>
            </div>

            <div class="bottom">
              <div class="feed-item" v-for="(feed,i) in city.data.feeds" :key="i">
                <div class="feed-name">
                  {{ feed.name }}
                </div>
                <div class="feed-percent text-right">
                  {{ Math.round(feed.capacity_percentage * 100) }}%
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="powered-by-citymesh">
          <a href="https://citymesh.com" title="Citymesh"><img src="@/assets/img/citymesh.svg" alt="Powered by Citymesh"></a>
        </div>
      </div>

      <Map v-show="viewMode == 'map'" />
    </div>
  </div>
</template>

<script>
import aalst from '@/assets/geojson/aalst.json'

import Map from './components/Map'
import { eventBus } from '@/event-bus.js'
import $Scriptjs from 'scriptjs'
import axios from 'axios'

var cityParam = null

export default {
  name: 'App',
  components: {
    Map
  },
  created () {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const city = urlParams.get('city')
    if (city) {
      cityParam = city
    }
  },
  mounted () {
    this.activeCity = cityParam
    // this.$getLocation({}).then(coordinates => {
    //   this.userCoordinates = coordinates
    //   console.log(coordinates)
    // })
    axios.get(process.env.VUE_APP_HOST + '/summary?tenants=' + process.env.VUE_APP_TENANTS).then((response) => {
      // response.data.forEach((item, i) => {
      //   this.cities.forEach((city, i) => {
      //     if (city.data.netbox_slug === item.name) {
      //       city.data.feeds = item.feeds
      //       city.data.feeds.forEach((feed, i) => {
      //         feed.g_circle = null
      //       })
      //     }
      //   })
      // })
      this.cities.forEach((city, i) => {
        // if (city.data.netbox_slug === item.name) {
        //   city.data.feeds = item.feeds
        //   city.data.feeds.forEach((feed, i) => {
        //     feed.g_circle = null
        //   })
        // }
        if (response.data[city.data.netbox_slug] && response.data[city.data.netbox_slug].feeds) {
          city.data.feeds = response.data[city.data.netbox_slug].feeds
          city.data.feeds.forEach((feed, i) => {
            feed.g_circle = null
          })
          city.data.devices = this.groupFeedsByDevice(city)
          city.avg = this.getCityAverageLoad(i)
        } else {
          city.avg = -1
        }
      })

      // this.cities.forEach((city, i) => {
      //   city.avg = this.getCityAverageLoad(i)
      // })

      $Scriptjs('https://maps.googleapis.com/maps/api/js?key=AIzaSyBDo8arlGzy1SUznuYn25Ajp2W5zt9myQY&language=nl&libraries=geometry,places,visualization,directions', () => {
        eventBus.$emit('googleLoaded')
        // this.getLocation()
      })
    })

    eventBus.$on('mapLoaded', () => {
      this.drawCities()
    })

    eventBus.$on('mouseoverCity', (payload) => {
      if (!this.detailView) {
        const color = this.cities[payload].cityData.style.fillColor
        this.cities[payload].cityData.setStyle({
          fillColor: color,
          fillOpacity: 0.75,
          strokeWeight: 1
        })
      }
    })

    eventBus.$on('mouseoutCity', (payload) => {
      if (!this.detailView) {
        const color = this.cities[payload].cityData.style.fillColor
        this.cities[payload].cityData.setStyle({
          fillColor: color,
          fillOpacity: 0.5,
          strokeWeight: 1
        })
      }
    })

    eventBus.$on('zoomChanged', (payload) => {
      switch (payload) {
        case 12:
          this.updateFeedRadius(150)
          break
        case 13:
          this.updateFeedRadius(100)
          break
        case 14:
          this.updateFeedRadius(90)
          break
        case 15:
          this.updateFeedRadius(80)
          break
        case 16:
          this.updateFeedRadius(60)
          break
        case 17:
          this.updateFeedRadius(40)
          break
        default:
      }
    })

    eventBus.$on('detailview', (payload) => {
      // console.log('detailview event', payload)
      if (!payload) {
        if (this.activeCity) {
          let paramName = this.activeCity
          paramName = paramName.replace('_', ' ')

          this.detailView = false
          // this.heatMap.set('opacity', 0)
          this.cities.forEach((item, i) => {
            if (item.data.name === paramName) {
              const color = item.cityData.style.fillColor
              item.cityData.setStyle({
                fillColor: color,
                fillOpacity: 0.5,
                strokeWeight: 1
              })

              item.data.devices.forEach((feed, i) => {
                if (feed.g_circle) {
                  feed.g_circle.setOptions({
                    strokeOpacity: 0,
                    fillOpacity: 0
                  })
                }
              })
            }
          })
        } else {
          this.detailView = false
          // this.heatMap.set('opacity', 0)
          this.cities.forEach((item, i) => {
            const color = item.cityData.style.fillColor
            item.cityData.setStyle({
              fillColor: color,
              fillOpacity: 0.5,
              strokeWeight: 1
            })

            item.data.devices.forEach((feed, i) => {
              if (feed.g_circle) {
                feed.g_circle.setOptions({
                  strokeOpacity: 0,
                  fillOpacity: 0
                })
              }
            })
          })
        }
      } else {
        if (this.activeCity) {
          let paramName = this.activeCity
          paramName = paramName.replace('_', ' ')

          this.detailView = true
          this.cities.forEach((item, i) => {
            if (item.data.name === paramName) {
              const color = item.cityData.style.fillColor
              item.cityData.setStyle({
                fillColor: color,
                fillOpacity: 0,
                strokeWeight: 1
              })
              item.data.devices.forEach((feed, i) => {
                if (feed.g_circle) {
                  feed.g_circle.setOptions({
                    strokeOpacity: 0.8,
                    fillOpacity: 0.55
                  })
                }
              })
            }
          })
        } else {
          this.detailView = true
          this.cities.forEach((item, i) => {
            const color = item.cityData.style.fillColor
            item.cityData.setStyle({
              fillColor: color,
              fillOpacity: 0,
              strokeWeight: 1
            })
            item.data.devices.forEach((feed, i) => {
              if (feed.g_circle) {
                feed.g_circle.setOptions({
                  strokeOpacity: 0.8,
                  fillOpacity: 0.55
                })
              }
            })
          })
        }
      }
    })
  },
  data () {
    return {
      logoImageType: process.env.VUE_APP_TENANT_LOGO_IMAGE_TYPE,
      groupName: process.env.VUE_APP_GROUP_NAME,
      detailView: false,
      heatMap: null,
      userCoordinates: null,
      viewMode: 'map',
      activeCity: null,
      cities: [
        {
          geojson: aalst,
          cityData: null,
          avg: null,
          visible: false,
          travelTime: null,
          data: {
            name: 'Aalst',
            netbox_slug: 'aalst',
            feeds: [],
            devices: []
          }
        }
      ]
    }
  },
  computed: {
    citiesFilter: function () {
      return this.cities.filter((el) => {
        return !this.activeCity || (this.activeCity && this.activeCity.replace('_', ' ') === el.data.name)
      })
    }
  },
  methods: {
    checkIfNegative (num) {
      if (num < 0) {
        return true
      } else {
        return false
      }
    },
    drawCities: function () {
      // geojson data from http://nominatim.openstreetmap.org/ needs
      // to be wrapped, so that the google addGeoJson() call
      // can handle it properly
      // var heatmapData = []

      if (!this.activeCity) {
        this.cities.forEach((city, index) => {
          const geoConf = {
            type: 'FeatureCollection',
            features: [
              {
                type: 'Feature',
                geometry: city.geojson,
                id: 'city'
              }
            ]
          }

          city.cityData = new window.google.maps.Data()
          city.cityData.addGeoJson(geoConf, 'city')
          if (city.avg < 0) {
            city.cityData.setStyle({
              fillColor: '#000',
              fillOpacity: 0.5,
              strokeWeight: 1
            })
          } else {
            city.cityData.setStyle({
              fillColor: this.perc2color(city.avg),
              fillOpacity: 0.5,
              strokeWeight: 1
            })
          }

          const cityObj = {
            index: index,
            name: city.name,
            mapData: city.cityData
          }
          // send data to our Map component
          eventBus.$emit('sendCityData', cityObj)

          // heatmap stuff
          city.data.devices.forEach((feed, i) => {
            if (feed.location_coordinates.lat && feed.location_coordinates.long) {
              const perc = feed.capacity_percentage * 100
              const color = this.perc2color(perc)
              feed.g_circle = new window.google.maps.Circle({
                strokeColor: color,
                strokeOpacity: 0,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0,
                center: new window.google.maps.LatLng(feed.location_coordinates.lat, feed.location_coordinates.long),
                radius: 100
              })
              let contentString =
              '<div class="map-infowindow-content">'
              feed.feeds.forEach((f, i) => {
                contentString += '<p><strong>' + f.name + ':</strong> ' + Math.round(f.capacity_percentage * 100) + '%</p>'
              })
              contentString += '</div>'
              feed.g_info = new window.google.maps.InfoWindow({
                content: contentString,
                position: new window.google.maps.LatLng(feed.location_coordinates.lat, feed.location_coordinates.long),
                maxWidth: 200
              })
            }
          })
        })

        eventBus.$emit('initHeatmap', this.cities)
      } else {
        let paramName = this.activeCity
        paramName = paramName.replace('_', ' ')

        this.cities.forEach((city, index) => {
          if (city.data.name === paramName) {
            const geoConf = {
              type: 'FeatureCollection',
              features: [
                {
                  type: 'Feature',
                  geometry: city.geojson,
                  id: 'city'
                }
              ]
            }

            city.cityData = new window.google.maps.Data()
            city.cityData.addGeoJson(geoConf, 'city')
            city.cityData.setStyle({
              fillColor: this.perc2color(city.avg),
              fillOpacity: 0.5,
              strokeWeight: 1
            })

            const cityObj = {
              index: index,
              mapData: city.cityData
            }
            // send data to our Map component
            // console.log(cityObj)
            eventBus.$emit('sendCityData', cityObj)

            // heatmap stuff
            city.data.devices.forEach((feed, i) => {
              if (feed.location_coordinates.lat && feed.location_coordinates.long) {
                const perc = feed.capacity_percentage * 100
                feed.g_circle = new window.google.maps.Circle({
                  strokeColor: this.perc2color(perc),
                  strokeOpacity: 0,
                  strokeWeight: 2,
                  fillColor: this.perc2color(perc),
                  fillOpacity: 0,
                  center: new window.google.maps.LatLng(feed.location_coordinates.lat, feed.location_coordinates.long),
                  radius: 100
                })
                let contentString =
                '<div class="map-infowindow-content">'
                feed.feeds.forEach((f, i) => {
                  contentString += '<p><strong>' + f.name + ':</strong> ' + Math.round(f.capacity_percentage * 100) + '%</p>'
                })
                contentString += '</div>'
                feed.g_info = new window.google.maps.InfoWindow({
                  content: contentString
                })
              }
            })
          }
        })

        eventBus.$emit('initHeatmap', this.cities)
      }
    },
    perc2color: function (perc) {
      var r; var g; var b = 0
      if (perc < 50) {
        g = 255
        r = Math.round(5.1 * perc)
      } else {
        r = 255
        g = Math.round(510 - 5.1 * perc)
      }
      var h = r * 0x10000 + g * 0x100 + b * 0x1
      return '#' + ('000000' + h.toString(16)).slice(-6)
    },
    getCityAverageLoad: function (i) {
      let total = 0
      let avg = 0

      this.cities[i].data.feeds.forEach((feed) => {
        total += feed.capacity_percentage
      })

      total = total * 100
      avg = total / this.cities[i].data.feeds.length
      if (isNaN(avg)) {
        avg = -1
      }

      return avg
    },
    getLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, (err) => {
          console.log('error:', err)
        }, {
          enableHighAccuracy: true
        })
      } else {
        alert('Geolocation is not supported by this browser.')
      }
    },
    showPosition: function (position) {
      this.userCoordinates = position.coords
      eventBus.$emit('userpositionknown', this.userCoordinates)
      // this.getDrivingTimes()
    },
    getDrivingTimes: function () {
      if (!this.activeCity) {
        this.cities.forEach((city, i) => {
          var directionsService = new window.google.maps.DirectionsService()
          directionsService.route(
            {
              origin: { query: this.userCoordinates.latitude + ',' + this.userCoordinates.longitude },
              destination: { query: city.data.name },
              travelMode: 'DRIVING'
            },
            function (response, status) {
              if (status === 'OK') {
                // console.log(city.data.name + ' time: ', response.routes[0].legs[0].duration.text)
                city.travelTime = response.routes[0].legs[0].duration.text
              } else {
                console.log('Directions request failed due to ' + status)
              }
            })
        })
      } else {
        let paramName = this.activeCity
        paramName = paramName.replace('_', ' ')
        this.cities.forEach((city, i) => {
          if (!this.activeCity || city.data.name === paramName) {
            var directionsService = new window.google.maps.DirectionsService()
            directionsService.route(
              {
                origin: { query: this.userCoordinates.latitude + ',' + this.userCoordinates.longitude },
                destination: { query: city.data.name },
                travelMode: 'DRIVING'
              },
              function (response, status) {
                if (status === 'OK') {
                  // console.log(city.data.name + ' time: ', response.routes[0].legs[0].duration.text)
                  city.travelTime = response.routes[0].legs[0].duration.text
                } else {
                  console.log('Directions request failed due to ' + status)
                }
              })
          }
        })
      }
    },
    updateFeedRadius: function (rad) {
      this.cities.forEach((item, i) => {
        item.data.devices.forEach((feed, i) => {
          if (feed.g_circle) {
            feed.g_circle.setOptions({
              radius: rad
            })
          }
        })
      })
    },
    groupFeedsByDevice: function (city) {
      const devices = []
      city.data.feeds.forEach((feed, i) => {
        let hit = false
        let did
        devices.forEach((device, i) => {
          if (feed.location_coordinates.lat === device.location_coordinates.lat && feed.location_coordinates.long === device.location_coordinates.long) {
            hit = true
            did = i
          }
        })
        if (hit) {
          // device is already in array -> push
          devices[did].feeds.push(feed)
        } else {
          // device is not yet in array -> make
          const dobj = {
            name: '',
            capacity_percentage: 0,
            location_coordinates: {
              lat: feed.location_coordinates.lat,
              long: feed.location_coordinates.long
            },
            feeds: []
          }
          dobj.feeds.push(feed)
          devices.push(dobj)
        }
      })
      // calc averages for devices
      devices.forEach((device, i) => {
        let total = 0
        // let max = 0
        device.feeds.forEach((feed, i) => {
          total += feed.capacity_percentage
          // if (feed.capacity_percentage > max) {
          //   max = feed.capacity_percentage
          // }
        })
        device.capacity_percentage = total / device.feeds.length
        // device.capacity_percentage = max
      })
      return devices
    }
  }
}
</script>

  <style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto');
  @import 'assets/sass/reset';
  @import 'assets/sass/variables';

  #app {
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  html,
  body {
    height: 100vh;
  }
  html { font-size: 62.5%; } /* =10px */
  body { font-size: 2.4rem; } /* =14px */
  #header{
    height: 9rem;
    font-size: 1.6rem;
    padding: 2rem;
    .logo{
      height: 5rem;
    }
  }
  #page {
    display: flex;
    height: calc( 100vh - 9rem);
  }
  #sidebar{
    width: 25rem;
    background: $primary;
    padding-top: 1rem;
    overflow-y: auto;
    position: relative;
    .cities-wrap{
      padding-bottom: 6rem;
      height: 100%;
      overflow-y: auto;
    }
    .powered-by-citymesh{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 5rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      background: $white;
      a{
        max-height: 20px;
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        img{
          max-height: 3rem;
          width: auto;
          margin: 0 auto;
          display: block;
          max-width: 70%;
        }
      }
    }
    .city-item{
      color: $white;
      font-weight: 700;
      font-size: 1.6rem;
      padding-left: 2rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      position: relative;
      .top{
        cursor: pointer;
      }
      .name{
        margin-bottom: 5px;
      }
      .percent{
        position: absolute;
        right: 4.2rem;
        top: 1rem;
      }
      .drive{
        position: relative;
        padding-left: 2rem;
        font-size: 1.1rem;
        font-weight: 400;
        line-height: 1.6rem;
      }
      .drive:before{
        content: "";
        width: 1.6rem;
        height: 1.6rem;
        background: url(assets/img/car.svg) no-repeat center center;
        background-size: 1.6rem;
        opacity: 0.4;
        position: absolute;
        left: 0;

      }
      .bottom{
        display: none;
      }
    }
    .city-item:after{
      content: "";
      position: absolute;
      right: 2rem;
      top: 1rem;
      width: 12px;
      height: 12px;
      background: url(assets/img/triangle.svg) no-repeat center center;
      background-size: 12px;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: transform 0.3s ease-out;
      -ms-transition: transform 0.3s ease-out;
      -o-transition: transform 0.3s ease-out;
      transition: transform 0.3s ease-out;
    }
    .city-item.show-bottom{
      .bottom{
        display: block;
        padding-top: 1rem;
        .feed-item{
          padding-left: 1.5rem;
          font-size: 1.4rem;
          display: flex;
          font-weight: 400;
          margin-bottom: 1rem;
          .feed-name{
            padding-right: 1rem;
          }
          .feed-percent{
            padding-left: 1rem;
            padding-right: 2rem;
            flex: 1 0 auto;
            font-weight: 700;
          }
        }
      }
    }
    .city-item.show-bottom:after{
      transform: rotate(180deg);
    }
  }
  #map-container{
    flex: 1 0 auto;
    background: $secondary;
    position: relative;
    #legend{
      position: absolute;
      bottom: 3rem;
      left: 1rem;color: rgb(86, 86, 86);
      font-size: 18px;
      background-color: rgb(255, 255, 255);
      padding: 10px;
      border-bottom-left-radius: 2px;
      border-top-left-radius: 2px;
      border: 0;
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
      width: 200px;
      font-weight: 500;
      z-index: 9999;
      .color-bar{
        width: 100%;
        height: 10px;
        background: linear-gradient(90deg, rgba(0,255,0,1) 0%, rgba(255,255,0,1) 50%, rgba(255,0,0,1) 100%);
      }
      .numbers{
        text-align: justify;
        display: flex;
        justify-content: space-between;
        padding-top: 2px;
        div{
          font-weight: 400;
        }
      }
      .labels{
        margin-top: 10px;
        .label{
          padding-left: 30px;
          position: relative;
          font-weight: 400;
        }
        .label:before{
          content: "";
          width: 20px;
          height: 10px;
          position: absolute;
          top: 3px;
          left: 0;
          box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
        }
        .green:before{
          background: rgb(0,255,0)
        }
        .yellow:before{
          background: rgb(255,255,0)
        }
        .red:before{
          background: rgb(255,0,0)
        }
      }
    }
    .btn-map{
      position: absolute;
      top: 6rem;
      left: 1rem;
      // margin: auto;
      z-index: 9999;
      text-align: center;
      height: 40px;
      vertical-align: middle;
      color: rgb(86, 86, 86);
      font-size: 18px;
      background-color: rgb(255, 255, 255);
      padding: 0px 17px;
      border-bottom-left-radius: 2px;
      border-top-left-radius: 2px;
      border: 0;
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
      min-width: 36px;
      font-weight: 500;
    }
    .btn-map:hover{
      color: rgb(0, 0, 0);
    }
  }
  #map{
    width: 100%;
    height: 100%;
  }

  /* TEXT */
  .text-right{
    text-align: right;
  }

  #view-switch{
    display: none;
  }

  @media only screen and (min-width: 768px){
    #sidebar, #map-container{
      display: block !important;
    }
  }

  @media only screen and (max-width: 768px){
    #header{
      height: 4rem;
      padding: 1rem;
      position: relative;
      .logo{
        height: 2rem;
      }
    }
    #page {
      display: block;
      height: auto;
    }
    #sidebar, #map-container{
      width: 100%;
      min-height: calc(100vh - 4rem);
    }
    #map-container{
      #map{
        height: calc(100vh - 4rem);
      }
    }
    #view-switch{
      display: block;
      position: absolute;
      right: 2rem;
      top: 0.5rem;
      button.square{
        height: 3rem;
        width: 3rem;
        background: $secondary-light;
        border: 0;
        color: $white;
        font-weight: 600;
        position: relative;
      }
      button.square:hover{
        background: $secondary;
      }
      button.square:focus{
        outline: none;
      }
      button.square.active{
        background: $primary
      }
      button.square.map:after, button.square.list:after{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 3rem;
        width: 3rem;
      }
      button.square.map:after{
        background: url(assets/img/map-outline.svg) no-repeat center center;
        background-size: 2rem;
      }
      button.square.list:after{
        background: url(assets/img/format-list-bulleted.svg) no-repeat center center;
        background-size: 2rem;
      }
    }
  }
  .map-infowindow-content{
    strong{
      font-weight: 700;
    }
  }
  </style>
